import { render, staticRenderFns } from "./AdminClientOrder.vue?vue&type=template&id=ff385c98&"
import script from "./AdminClientOrder.vue?vue&type=script&lang=js&"
export * from "./AdminClientOrder.vue?vue&type=script&lang=js&"
import style0 from "./AdminClientOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports